interface EspWebInstallButtonOptions {
  manifest: string;
  baudRate: number;
  installHeadlineFast?: string;
}

export function configureEspWebInstallButton(
  installButton: HTMLElement,
  options: EspWebInstallButtonOptions,
): void {
  installButton.setAttribute('manifest', options.manifest);
  installButton.setAttribute('data-baud-rate', options.baudRate.toString());
  installButton.setAttribute('data-post-flash-identify', 'true');

  if (options.installHeadlineFast) {
    installButton.setAttribute('data-install-headline-fast', options.installHeadlineFast);
  }
}
